/****************************************************
 * Module Name:  changeLocationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button, Tooltip } from "@mui/material";
import Select from "react-select";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect } from "react";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import { MdEditLocationAlt } from "react-icons/md";

const ChangeLocationModal = ({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  sourceData,
  loading
}) => {
  const [locationData, SetLocationData] = useState({
    location: "",
    locationOptions: [],
  });
  const [remark, setRemark] = useState("");
  const [locationLoader, SetLocationLoader] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    getAllLocationData();
  }, []);

  const getAllLocationData = () => {
    SetLocationLoader(true);
    LocationProxy.GetAllLocationDetailMini((response) => {
      setDataLocation(response);
      SetLocationLoader(false);
    });
  };

  const setDataLocation = (response) => {
    let optionsArray = [];
    response.map((data) => {
      if (data.id !== Constants.loggedInUser.locationid) {
        let option = {
          value: data.id,
          label: data.name + " | " + data.country,
        };
        optionsArray.push(option);
      }
      return true;
    });
    SetLocationData({
      ...locationData,
      locationOptions: optionsArray,
      location:
        locationData.location === "" && optionsArray.length > 0
          ? optionsArray[0]
          : locationData.location,
    });
  };

  const saveHandler = () => {
    let data = {
      locationid: locationData.location.value,
      userid: Constants.loggedInUser.id,
      remark: remark,
      stones: stoneId,
    };
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add locationId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            change location validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Select a location
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box style={{ width: "8%" }}>
              <Form.Label>location</Form.Label>
            </Box>
            <Box style={{ width: "92%" }}>
              <Select menuPlacement="auto"
                blurInputOnSelect={false}
                className="basic-single"
                classNamePrefix="select"
                value={locationData.location}
                isSearchable={true}
                name="location"
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                options={locationData.locationOptions}
                onChange={(selectedOption) =>
                  SetLocationData({
                    ...locationData,
                    location: selectedOption,
                  })
                }
              />
            </Box>
            <Box>
              {locationLoader ? (
                <CircularProgress size="1rem" />
              ) : (
                <Tooltip title="Reload List">
                  <RefreshOutlinedIcon
                    color="primary"
                    fontSize="large"
                    sx={{ cursor: "pointer" }}
                    onClick={getAllLocationData}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box>
            <LoadingButton
              color="success"
              variant="contained"
              onClick={saveHandler}
              type="Submit"
              sx={{ mr: 3 }}
              loading={loading}
              loadingPosition="start"
              startIcon={<MdEditLocationAlt />}
              disabled={locationLoader}
            >
              Change
            </LoadingButton>
          </Box>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChangeLocationModal;
